export default __webpack_public_path__ + "static/media/brush-icon.460e6ef2.svg";